import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

import { LoginProps } from 'models/api';

import { asyncPayloadCreator } from 'utils';

export const login = createAsyncThunk(
	'authorization/login',
	(credentials: LoginProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, AccountService.login),
);
